enum RouteNames {
  CREATE_CLAIM = "create-claim",
}

export default RouteNames;
